export default "__VITE_ASSET__DedK8hKj__"